import script from "./backTop.vue?vue&type=script&setup=true&lang=js"
export * from "./backTop.vue?vue&type=script&setup=true&lang=js"

import "./backTop.vue?vue&type=style&index=0&id=754808c4&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754808c4"]])

export default __exports__